<div (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()" [cdkMenuTriggerFor]="menu">
  <ng-content></ng-content>
</div>

<ng-template #menu>
  <!-- this wrapper and spacer div is to have a transparent space between the menu and the icon without leaving the menu which would close it -->
  <div class="wrapper-menu" cdkMenu>
    <div class="spacer"></div>
    <div class="wrapper-menu-items">
      @for (item of navItems(); track item) {
        <ui-menu-item [item]="item"></ui-menu-item>
      }
    </div>
  </div>
</ng-template>
